module.exports = __webpack_public_path__ + "static/media/icon-manager-light.7d93b35a.svg";